import tableRelatedAppSportRoomConfigs from './tableRelatedAppSportRoomConfigs';

export default {
  title: 'App/Room Configs',
  attributeName: 'appConfigs',
  getURL: 'appSportRoomConfigs',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedAppSportRoomConfigs,
};
